import React from "react";
import InvalidMessage from "venuescanner-js/react/components/Form/Notifications/InvalidMessage";
import placeholders from "venuescanner-js/react/components/Form/copy/placeholders";
import classes from "./Input.module.scss";

import cl from "classnames";

function Input(props) {
  const {
    errors = {},
    touched = {},
    type = "text",
    label,
    name,
    register = () => ({}),
    keyPress,
    isCurrency,
    currency,
    maxValue,
    value,
    handleChange,
    disabled,
    autocomplete,
    includeValidity = false,
  } = props;
  const standardNavChars = [
    "ArrowLeft",
    "ArrowRight",
    "Backspace",
    "Delete",
    "Shift",
  ];
  const validChars = isCurrency
    ? [..."0123456789.".split(""), ...standardNavChars]
    : null;
  const handleKeyDown = (ev) => {
    if (validChars && !validChars.includes(ev.key)) {
      ev.preventDefault();
      return false;
    }
    if (keyPress) {
      keyPress.keys.forEach((key) => {
        if (ev.key === key) {
          keyPress.action(keyPress.value);
          ev.target.blur();
        }
      });
    }
  };
  const handleKeyUp = (ev) => {
    if (!isNaN(maxValue)) {
      if (ev.target.value > maxValue) ev.target.value = maxValue.toString();
    }
  };

  return (
    <div
      className={cl([
        classes.input,
        { "form-error": errors[name] && (!touched || touched[name]) },
      ])}
    >
      {label && <label>{label}</label>}
      {isCurrency && (
        <span className="input-ccy">{currency.currency.symbol}</span>
      )}
      <input
        name={name}
        {...register(name)}
        type={type}
        placeholder={placeholders[name]}
        onKeyDown={handleKeyDown}
        onKeyUp={handleKeyUp}
        onChange={(e) => {
          if (handleChange) handleChange(e);
        }}
        autoComplete={autocomplete}
        disabled={disabled}
        defaultValue={value || ""}
      />
      {includeValidity && (
        <InvalidMessage error={(!touched || touched[name]) && errors[name]} />
      )}
    </div>
  );
}

export default Input;
